/**
 * The old effect methods of `Sfx` (audio.ts: `sfx.swing()`, `sfx.hit()` …), each now a sound of the
 * registry. Their call sites (render/effects.ts, render/fx/*.ts, the cutscenes) keep working; while
 * the event mapping has spoken for the event being handled they stay silent (sfx/events.ts).
 */
import { sfxEngine } from './engine';

export const LEGACY_SFX = {
  swing: 'combat.swing.sword.light',
  ching: 'combat.ching',
  hit: 'combat.hit.slash',
  hurt: 'combat.hurt',
  block: 'combat.block',
  guardBreak: 'combat.guardBreak',
  interrupt: 'combat.interrupt',
  charge: 'combat.charge',
  bolt: 'skill.fx.bolt',
  nine: 'skill.fx.nine',
  dash: 'move.dash',
  jump: 'move.jump',
  heal: 'skill.heal',
  train: 'ui.trained',
  coin: 'econ.coin',
  boom: 'combat.boom',
  gongHit: 'world.gong',
  heartbeat: 'scene.heartbeat',
  waves: 'scene.waves',
  whisper: 'scene.whisper',
  land: 'move.land',
} as const;

export type LegacySfx = keyof typeof LEGACY_SFX;

/** Plays an old effect method's sound (unless the event mapping already did). */
export const legacySfx = (name: LegacySfx): void => sfxEngine.legacy(LEGACY_SFX[name]);
